// extracted by mini-css-extract-plugin
module.exports = {"socials":"SocialLinks_socials__jzOsF","icon":"SocialLinks_icon__0YYFR","medium":"SocialLinks_medium___hrKV","small":"SocialLinks_small__h3rcQ"};